import {mediaQueryBreakpointMD} from "../Utils/Utils";

const LanguageSwitcher = () => {

	const langSwitchers = document.querySelectorAll('.language-switcher');

	langSwitchers.forEach((langSwitcher) => {

		const switchBtn = langSwitcher.querySelector('.switch-btn');

		switchBtn.addEventListener('click', (e) => {
			e.preventDefault();

			if(window.innerWidth < mediaQueryBreakpointMD) {

				e.preventDefault();

				if(langSwitcher.classList.contains('js-revealed')) {
					langSwitcher.classList.remove('js-revealed');
					langSwitcher.classList.add('js-concealed');
				}
				else {
					langSwitcher.classList.add('js-revealed');
				}
			}
		});

		// No touch devices
		langSwitcher.addEventListener('mouseover', (e) => {
			if(window.innerWidth >= mediaQueryBreakpointMD) {
				langSwitcher.classList.add('js-revealed');
			}
		});
		langSwitcher.addEventListener('mouseleave', (e) => {
			if(window.innerWidth >= mediaQueryBreakpointMD) {
				langSwitcher.classList.remove('js-revealed');
			}
		});
	});
};

export default LanguageSwitcher;